/** Shared page setup, resolved once on load. */
export interface AppSetup {
  /** Scroll offset past which the header becomes sticky. */
  headOffset: number;
  header: HTMLElement | null;
}

const header = document.getElementById('header');

export const appSetup: AppSetup = {
  header,
  headOffset: header?.offsetTop ?? 80,
};
